module.exports = __webpack_public_path__ + "img/filter.6822f6b9.svg";